export enum TwoFactorMethod {
  None = 0,
  WebAuthn = 1,
  Email = 2,
  Mobile = 3,
  Totp = 4,
}
